import styled from 'styled-components';
import { GhostInfoButton } from 'ui/button';

export const CollectionsContainer = styled.div`
  display: flex;
  > *:last-of-type {
    flex: 1;
  }
`;

export const StyledGhostInfoButton = styled(GhostInfoButton)`
  height: unset;
`;
